import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Modal as AntModal } from 'antd'

import './Modal.less'

export default class Modal extends PureComponent {
  render() {
    const { className } = this.props
    const ModalClassName = classNames(className, 'pan-modal')
    const ModalProps = Object.assign({
      okText: 'OK',
      cancelText: 'Cancel',
      okType: 'primary'
    }, { ...this.props }, { className: ModalClassName })
    return <AntModal {...ModalProps} />
  }
}

// add modal methods
for (const method of ['info', 'success', 'error', 'warning', 'confirm']) {
  const addResolver = (fn, resolve, value) => (!fn ? () => resolve(value) : (e) => {
    const ret = fn(e)
    if (ret && ret.then) {
      ret.then(() => resolve(value), () => resolve(value))
    }
    else {
      resolve(value)
    }
    return ret
  })
  Modal[method] = (options = {}) => {
    const promise = options.promisify ? new Promise((resolve) => {
      const { onOk, onCancel, onDestroy } = options
      options.onOk = addResolver(onOk, resolve, true)
      options.onCancel = addResolver(onCancel, resolve, false)
      options.onDestroy = addResolver(onDestroy, resolve, null)
    }) : {}
    options.className = classNames(options.className, 'pan-modal')
    const ref = AntModal[method](options)
    ref.options = options
    if (options.promisify) {
      const { destroy } = ref
      ref.destroy = () => {
        destroy()
        options.onDestroy()
      }
    }
    return Object.assign(promise, ref)
  }
}

Modal.AntModal = AntModal
